import React, { useState, useEffect } from "react";
import {
  Switch,
  Input,
  Button,
  notification,
  Modal as ModalAntd,
  Table,
  BackTop
} from "antd";
import {
  EditOutlined,
  StopOutlined,
  DeleteOutlined,
  CheckOutlined,
  PlusOutlined
} from "@ant-design/icons";

import { Popover } from "antd";
import Modal from "../../../Modal";
import EditDocTypeForm from "../EditDocTypeForm";
import AddDocTypeForm from "../AddDocTypeForm";
import { activateDocTypeApi, deleteDocTypeApi } from "../../../../api/docType";
import { getAccessToken } from "../../../../api/auth";
import { checkAction, isAdmin } from "../../../../utils/checkUserPermission";
import { getRoleByIdApi } from "../../../../api/role";
import { getPermissionsActiveApi } from "../../../../api/permission";
import { getStudentsByDocTypeApi} from "../../../../api/student";
import jwtDecode from "jwt-decode";

import "./ListDocTypes.scss";

const { confirm } = ModalAntd;
const { Search } = Input;

export default function ListDocTypes(props) {
  const {
    docTypesActive,
    docTypesInactive,
    setReloadDocTypes,
  } = props;
  const [permissionsActive, setPermissionsActive] = useState([]);
  const [roleById, setRoleById] = useState([]);
  const [viewDocTypesActives, setViewDocTypesActives] = useState(true);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  const [filterText, setFilterText] = useState("");
  const [docTypesActiveFilter, setDocTypesActiveFilter] = useState(
    []
  );
  const [ docTypesInactiveFilter, setDocTypesInactiveFilter ] = useState([]);

  const accessToken = getAccessToken();
  const userToken = jwtDecode(accessToken); //para obtener los datos del user logueado

  useEffect(() => {
    getPermissionsActiveApi(accessToken, true).then(response => {
      setPermissionsActive(response.permissions);
    });
  }, []);

  useEffect(() => {
    getRoleByIdApi(accessToken, userToken.role).then(response => {
      setRoleById(response.role);
    });
  }, []);

  useEffect(() => {
    const listActive = [];
    if (docTypesActive) {
      docTypesActive.forEach((element) => {
          if (
            element.description
              .toUpperCase()
              .includes(filterText.toUpperCase()) ||
            element.doctype_code.toString()
              .toUpperCase()
              .includes(filterText.toUpperCase()) ||
            filterText === ""
          ) {
            listActive.push(element);
          }
      });
    }
    setDocTypesActiveFilter(listActive);
  }, [filterText, docTypesActive]);

  useEffect(() => {
    const listInactive = [];
    if (docTypesInactive) {
      docTypesInactive.forEach((element) => {
          if (
            element.description
              .toUpperCase()
              .includes(filterText.toUpperCase()) ||
            element.doctype_code.toString()
              .toUpperCase()
              .includes(filterText.toUpperCase()) ||
            filterText === ""
          ) {
            listInactive.push(element);
          }
      });
    }
    setDocTypesInactiveFilter(listInactive);
  }, [filterText, docTypesInactive]);

  const addDocTypeModal = () => {
    setIsVisibleModal(true);
    setModalTitle("Crear Tipo de documento");
    setModalContent(
      <AddDocTypeForm
        setIsVisibleModal={setIsVisibleModal}
        setReloadDocTypes={setReloadDocTypes}
      />
    );
  };

  return (
    <div className="list-doctypes">
      <div className="list-doctypes__header">
        {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
        checkAction(permissionsActive, userToken.role, "docTypes", "enable") || isAdmin(roleById) ? (
          <>
            <div className="list-doctypes__header-switch">
              <Switch
                defaultChecked
                onChange={() =>
                  setViewDocTypesActives(!viewDocTypesActives)
                }
              />
              <span>
                {viewDocTypesActives
                  ? "Activos"
                  : "Inactivos"}
              </span>
            </div>
          </>
          ) : (
            <>
            </>
        )}

        {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
        checkAction(permissionsActive, userToken.role, "docTypes", "add") || isAdmin(roleById) ? (
          <>
            <Button type="primary" icon={<PlusOutlined/>} onClick={addDocTypeModal}>
              Nuevo
            </Button>
          </>
        ) : (
          <>
          </>
        )}
      </div>

      {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
      checkAction(permissionsActive, userToken.role, "docTypes", "view") || isAdmin(roleById) ? (
        <>
          <div className="list-doctypes__search">
            <Search
              className="Buscar"
              placeholder=""
              onChange={(e) => setFilterText(e.target.value)}
              enterButton
            />
            <h2>

            </h2>
            <h3>
              <strong>Info</strong> ejemplos de tipos de documento: DNI, CI, pasaporte, registro de conducir.
            </h3>
          </div>
        </>
      ) : (
        <>
        </>
      )}

      {viewDocTypesActives ? (
        <>
          {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
          checkAction(permissionsActive, userToken.role, "docTypes", "view") || isAdmin(roleById) ? (
            <>
              <DocTypesActive
                docTypesActive={docTypesActiveFilter}
                setIsVisibleModal={setIsVisibleModal}
                setModalTitle={setModalTitle}
                setModalContent={setModalContent}
                setReloadDocTypes={setReloadDocTypes}
                accessToken={accessToken}
                userToken={userToken}
                permissionsActive={permissionsActive}
                roleById={roleById}
              />
            </>
          ) : (
            <>
            </>
          )}
        </>
      ) : (
        <>
          {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
          checkAction(permissionsActive, userToken.role, "docTypes", "view") || isAdmin(roleById) ? (
            <>
              <DocTypesInactive
                docTypesInactive={docTypesInactiveFilter}
                setIsVisibleModal={setIsVisibleModal}
                setReloadDocTypes={setReloadDocTypes}
                setModalTitle={setModalTitle}
                setModalContent={setModalContent}
                accessToken={accessToken}
                userToken={userToken}
                permissionsActive={permissionsActive}
                roleById={roleById}
              />
            </>
          ) : (
            <>
            </>
          )}
        </>
      )}

      <Modal
        title={modalTitle}
        isVisible={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={800}
      >
        {modalContent}
      </Modal>

      <BackTop/>
    </div>
  );
}

function DocTypesActive(props) {
  const {
    docTypesActive,
    setIsVisibleModal,
    setModalTitle,
    setModalContent,
    setReloadDocTypes,
    accessToken,
    userToken,
    permissionsActive,
    roleById
  } = props;

  const editDocType = (docType) => {
    setIsVisibleModal(true);
    setModalTitle(
      `Editar ${docType.description ? docType.description : "sin descripcion"}`
    );
    setModalContent(
      <EditDocTypeForm
        docType={docType}
        setIsVisibleModal={setIsVisibleModal}
        setReloadDocTypes={setReloadDocTypes}
      />
    );
  };

  const desactivateDocType = (docType) => {
    activateDocTypeApi(accessToken, docType._id, false)
      .then((response) => {
        notification["success"]({
          message: response.message,
        });
        setReloadDocTypes(true);
      })
      .catch((err) => {
        notification["error"]({
          message: err,
        });
      });
  };

  const showDeleteConfirm = async (docType) => {
    let response = await getStudentsByDocTypeApi(accessToken, docType._id);
    if (response.students.length > 0) {
      confirm({
        title: "Eliminando -> Tipo de documento",
        content: `No se puede eliminar '${docType.description}' porque existen estudiantes asociados ¿Deseas desactivarlo?`,
        okText: "Desactivar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          desactivateDocType(docType);
        },
      });
    } else {
      confirm({
        title: "Eliminando -> Tipo de documento",
        content: `¿Estás seguro que quieres eliminar a ${docType.description? docType.description : "sin descripción"}?`,
        okText: "Eliminar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          deleteDocTypeApi(accessToken, docType._id)
            .then((response) => {
              if (response.code === 200) {
                notification["success"]({
                  message: response.message,
                });
                setReloadDocTypes(true);
              } else if (response.code === 404 || response.code === 500) {
                notification["error"]({
                  message: response.message,
                });
              } else if (
                response === "ERR_CONNECTION_REFUSED" ||
                response === "Failed to fetch" ||
                response === undefined
              ) {
                notification["error"]({
                  message: "Servidor caido",
                });
              } else {
                notification["error"]({
                  message: "Error del servidor",
                });
              }
            })
            .catch((err) => {
              notification["error"]({
                message: err,
              });
            });
        },
      });
    }
  };

  const edit_docType= (
    <div>
      {" "}
      <p>Editar Tipo de documento</p>{" "}
    </div>
  );

  const desactivate_docType = (
    <div>
      {" "}
      <p>Pasar a tipos de documento inactivos</p>{" "}
    </div>
  );

  const delete_docType = (
    <div>
      {" "}
      <p>Eliminar tipo de documento</p>{" "}
    </div>
  );

  const columns = [
    {
      title: "Código",
      dataIndex: "doctype_code",
    },
    {
      title: "Descripción",
      dataIndex: "description",
    },
    {
      title: "Acción",
      key: "action",
      render: (text, docType) => (
        <div>
          {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
          checkAction(permissionsActive, userToken.role, "docTypes", "edit") || isAdmin(roleById) ? (
            <>
              <Popover content={edit_docType}>
                <Button
                  className="button-edit"
                  type="default"
                  onClick={() => editDocType(docType)}
                >
                  <EditOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
          checkAction(permissionsActive, userToken.role, "docTypes", "enable") || isAdmin(roleById) ? (
            <>
              <Popover content={desactivate_docType}>
                <Button
                  className="button-doctype"
                  type="primary"
                  onClick={() => desactivateDocType(docType)}
                >
                  <StopOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
          checkAction(permissionsActive, userToken.role, "docTypes", "delete") || isAdmin(roleById) ? (
            <>
              <Popover content={delete_docType}>
                <Button
                  className="button-doctype"
                  type="danger"
                  onClick={() => showDeleteConfirm(docType)}
                >
                  <DeleteOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      footer={()=>{return docTypesActive.length > 0? `Total de registros: ${docTypesActive.length}`: false}}
      pagination={{
        pageSize: 50,
        showSizeChanger: false,
      }}
      dataSource={docTypesActive}
      columns={columns}
      rowKey="_id"
    />
  );
}

function DocTypesInactive(props) {
  const { docTypesInactive,
          setReloadDocTypes,
          accessToken,
          userToken,
          permissionsActive,
          roleById
        } = props;

  const activateDocType = (docType) => {
    activateDocTypeApi(accessToken, docType._id, true)
      .then((response) => {
        notification["success"]({
          message: response.message,
        });
        setReloadDocTypes(true);
      })
      .catch((err) => {
        notification["error"]({
          message: err,
        });
      });
  };

  const showDeleteConfirm = async (docType) => {
    let response = await getStudentsByDocTypeApi(accessToken, docType._id);
    if (response.students.length > 0) {
      ModalAntd.info({
        title: "Eliminando -> Tipo de documento",
        content:`No se puede eliminar '${docType.description}' porque existen estudiantes asociados a él`,
        onOk(){},
      });
    } else {
      confirm({
        title: "Eliminando -> Tipo de documento",
        content: `¿Estás seguro que quieres eliminar a ${docType.description? docType.description : "sin descripción"}?`,
        okText: "Eliminar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          deleteDocTypeApi(accessToken, docType._id)
            .then((response) => {
              if (response.code === 200) {
                notification["success"]({
                  message: response.message,
                });
                setReloadDocTypes(true);
              } else if (response.code === 404 || response.code === 500) {
                notification["error"]({
                  message: response.message,
                });
              } else if (
                response === "ERR_CONNECTION_REFUSED" ||
                response === "Failed to fetch" ||
                response === undefined
              ) {
                notification["error"]({
                  message: "Servidor caido",
                });
              } else {
                notification["error"]({
                  message: "Error del servidor",
                });
              }
            })
            .catch((err) => {
              notification["error"]({
                message: err,
              });
            });
        },
      });
    }
  };

  const activate_docType = (
    <div>
      {" "}
      <p>Pasar a tipos de documento activos</p>{" "}
    </div>
  );

  const delete_docType = (
    <div>
      {" "}
      <p>Eliminar tipo de documento</p>
    </div>
  );

  const columns = [
    {
      title: "Código",
      dataIndex: "doctype_code",
    },
    {
      title: "Descripción",
      dataIndex: "description",
    },
    {
      title: "Acción",
      key: "action",
      render: (text, docType) => (
        <div>
          {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
          checkAction(permissionsActive, userToken.role, "docTypes", "enable") || isAdmin(roleById) ? (
            <>
              <Popover content={activate_docType}>
                <Button
                  className="button-activate"
                  onClick={() => activateDocType(docType)}
                >
                  <CheckOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "docTypes", "all") ||
          checkAction(permissionsActive, userToken.role, "docTypes", "delete") || isAdmin(roleById) ? (
            <>
              <Popover content={delete_docType}>
                <Button
                  className="button-doctype"
                  type="danger"
                  onClick={() => showDeleteConfirm(docType)}
                >
                  <DeleteOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      footer={()=>{return docTypesInactive.length > 0? `Total de registros: ${docTypesInactive.length}`: false}}
      pagination={{
        pageSize: 50,
        showSizeChanger: false,
      }}
      dataSource={docTypesInactive}
      columns={columns}
      rowKey="_id"
    />
  );
}
